import { createContext, useContext, useEffect } from "react";

export type Crumb = { label: string; to?: string };
export const CrumbCtx = createContext<(c: Crumb[]) => void>(() => {});

/** Sets the top-bar breadcrumbs and document title for the current page (prototype `useCrumbs`). */
export function useCrumbs(crumbs: Crumb[]) {
  const set = useContext(CrumbCtx);
  const key = crumbs.map((c) => c.label).join("/");
  // biome-ignore lint/correctness/useExhaustiveDependencies: keyed by the labels on purpose
  useEffect(() => {
    set(crumbs);
    document.title = `${crumbs[crumbs.length - 1]?.label ?? "Keel"} · Keel`;
  }, [key]);
}
